import React from 'react';
import * as Yup from 'yup';
import _ from 'lodash';
import { FormContainer, Row } from '~/views/emails-template/styles';
import { InputGroup, Select, Autocomplete, RichEditor } from '~/components/form';

export const emailVariables = [
  { id: 'event.name', label: 'Nome do Evento' },
  { id: 'company.name', label: 'Razão Social' },
  { id: 'company.tradeName', label: 'Nome Fantasia' },
  { id: 'user.name', label: 'Nome do Responsavel' },
  { id: 'cabine', label: 'Nº Cabine/Tribuna' },
  { id: 'tribuna', label: 'Tipo de acesso' },
  { id: 'allPersons', label: 'Todos Colaboradores' },
  { id: 'reprovedPersons', label: 'Colaboradores Reprovados' },
];

export const EmailsTemplateSchema = Yup.object().shape({
  subject: Yup.string().required('Informe o Assunto'),
  type: Yup.string().required('Informe o Tipo'),
  contents: Yup.string().required('Informe o Conteúdo'),
  place: Yup.mixed().test('', 'Informe o Local', function() {
    const { path, parent } = this
    return !_.isEmpty(_.get(parent, path));
  }),
});

export const typesList = [
  { value: 'press-accreditation-approved', label: 'Credenciamento Aprovado' },
  { value: 'press-accreditation-reproved', label: 'Credenciamento Rejeitado' },
];

export const EmailsTemplateForm = ({ values, errors, touched, previewMode, onListPlaces }) => {

  return (
    <FormContainer>
      <InputGroup
        type="text"
        name="subject"
        label="Assunto"
        required={true}
        maxLength={100}
        autoFocus
        disabled={previewMode}
        hasError={errors.subject && touched.subject} />

      <Row>
        <Select
          name="type"
          label="Tipo"
          required={true}
          disabled={previewMode}
          options={{ values: [
            { value: '', label: 'Selecione um tipo' },
            ...typesList
          ]}}
          hasError={_.get(errors, 'type') && _.get(touched, 'type')} />

        <Autocomplete
          name='place'
          minLength={0}
          keyField='id'
          label="Local"
          disabled={previewMode}
          value={values && values.place}
          valueFormat={(row) => `${row.name}`}
          loadData={onListPlaces}
          required={true}
          emptyText={'Pesquise um local'}
          tipText={'Digite... '}
          loadingText={'Carregando...'}
          notFoundText={'Não encontrado'}
          />
      </Row>

      <RichEditor
        name="contents"
        placeholder="Conteúdo"
        disabled={previewMode}
        heightText='calc(100vh - 388px)'
        variables={emailVariables}
        />

    </FormContainer>
  );
};
